import { render } from "./ACol.vue?vue&type=template&id=4c13f6b6&scoped=true"
import script from "./ACol.vue?vue&type=script&lang=js"
export * from "./ACol.vue?vue&type=script&lang=js"

import "./ACol.vue?vue&type=style&index=0&id=4c13f6b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c13f6b6"]])

export default __exports__